/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Releasedate_Releasedsameday4Inputs */

const id_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirilis di Epic pada hari yang sama dengan PC`)
};

const ms_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikeluarkan di Epic pada hari yang sama dengan PC`)
};

const da_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivet på Epic samme dag som på PC`)
};

const de_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichzeitig mit PC auf Epic veröffentlicht`)
};

const en_us2_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released on Epic the same day as PC`)
};

const es_es2_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado en Epic el mismo día que en PC`)
};

const es_mx2_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado en Epic el mismo día que en PC`)
};

const fil_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inilabas sa Epic kasabay ng PC`)
};

const fr_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorti sur Epic le même jour que sur PC`)
};

const it_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscito su Epic lo stesso giorno del PC`)
};

const hu_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelent Epic-en ugyanazon a napon, mint PC-n`)
};

const nl_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op dezelfde dag als pc uitgebracht op Epic`)
};

const no_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgitt på Epic samme dag som PC`)
};

const pl_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydane na Epic tego samego dnia co na PC`)
};

const pt_br2_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançado na Epic no mesmo dia que PC`)
};

const pt_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançado na Epic no mesmo dia que no PC`)
};

const ro_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansat pe Epic în aceeași zi ca pe PC`)
};

const fi_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaistu Epicissä samana päivänä kuin PC:lle`)
};

const sv_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släppt på Epic samma dag som på PC`)
};

const vi_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành trên Epic cùng ngày với PC`)
};

const tr_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC ile aynı gün Epic'te yayınlandı`)
};

const cs_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydáno na Epic stejný den jako na PC`)
};

const bg_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издадено на Epic на същия ден като PC`)
};

const ru_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вышло в Epic Games Store в тот же день, что и на ПК`)
};

const uk_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Випущено в Epic того ж дня, що й на ПК`)
};

const ar_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صدر على Epic في نفس يوم إصدار PC`)
};

const hi_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC के उसी दिन Epic पर रिलीज़ हुआ`)
};

const th_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วางจำหน่ายบน Epic วันเดียวกับ PC`)
};

const ja_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC版と同日にEpicでリリース`)
};

const zh_cn2_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与PC同日于Epic发布`)
};

const zh_hant1_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與PC同日於Epic發布`)
};

const ko_offerdetail_releasedate_releasedsameday4 = /** @type {(inputs: Offerdetail_Releasedate_Releasedsameday4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC와 같은 날 Epic에 출시됨`)
};

/**
* | output |
* | --- |
* | "Released on Epic the same day as PC" |
*
* @param {Offerdetail_Releasedate_Releasedsameday4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_releasedate_releasedsameday4 = /** @type {((inputs?: Offerdetail_Releasedate_Releasedsameday4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Releasedate_Releasedsameday4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "ms") return ms_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "da") return da_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "de") return de_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "en-US") return en_us2_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "fil") return fil_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "fr") return fr_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "it") return it_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "hu") return hu_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "nl") return nl_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "no") return no_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "pl") return pl_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "pt") return pt_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "ro") return ro_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "fi") return fi_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "sv") return sv_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "vi") return vi_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "tr") return tr_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "cs") return cs_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "bg") return bg_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "ru") return ru_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "uk") return uk_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "ar") return ar_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "hi") return hi_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "th") return th_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "ja") return ja_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_releasedate_releasedsameday4(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_releasedate_releasedsameday4(inputs)
	return ko_offerdetail_releasedate_releasedsameday4(inputs)
});
export { offerdetail_releasedate_releasedsameday4 as "offerDetail.releaseDate.releasedSameDay" }